import LazyLoad from "react-lazyload";

import dynamic from "next/dynamic";

import CheckContent from "components/atoms/CheckContent";
import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import FormCountries from "components/molecules/FormCountries";
import FormNewsLetter from "components/molecules/FormNewsletter";
import Banner from "components/organisms/Banner";
import EbookDownload from "components/organisms/EbookDownload/index";
import Faqs from "components/organisms/Faqs";
import HowItWorks from "components/organisms/HowItWorks";
import OffshoreCompanyRegistration from "components/organisms/OffshoreCompanyRegistration";
import RequiredDocument from "components/organisms/RequiredDocument";
import StepSlider from "components/organisms/StepSlider";
import WhatMakeUsDifferent from "components/organisms/WhatMakeUsDifferent";

import CompanyNameCheck from "./CompanyNameCheck";
const NewsSlider = dynamic(() => import("components/organisms/NewsSlider"), {
  ssr: false,
});

const SGCompanyIncorporationTemplate = ({ data, dataJson }) => {
  return (
    <>
      <Banner
        minHeightBanner="banner-min-h-635"
        breadcrumbs={dataJson.breadcrumbs}
        title={"Company Incorporation <br/>In Singapore"}
        titleProps={{
          className: "banner-default-title mb-6 lg:mb-10 capitalize",
          textColor: "banner-title-default-color",
        }}
        leftClassName="lg:col-7"
        rightClassName="lg:col-5"
        rightContent={
          <Img
            src={
              "/assets/images/sg/company-incorporation/banner-sg-incorporation.png"
            }
            wrapper={{
              className: "bbc-banner-image-country pb-10 lg:pb-0 ",
            }}
            className="w-full"
            width={560}
            height={456}
            priority={true}
            alt="Singapore company incorporation service"
          />
        }
        bgColor={"bg-bbc-country"}
        dataTrustpilot={{
          dataStatic: dataJson.dataTrustpilot,
          dataDefault: data.dataTrustpilot,
        }}
      />
      <section className="mt-10 lg:mt-20">
        <OffshoreCompanyRegistration data={dataJson.dataRegistration} />
      </section>
      <Img
        src="/assets/images/wave/opposition-wave.png"
        width={1920}
        height={86}
        className="hidden w-full lg:block"
        wrapper={{ className: "w-full" }}
        alt="Wave opposition"
      />
      <div className="lg:bg-bbc-brand-100">
        <div className="container ">
          {/* <RefundGuarantee className="mb-10 pt-6 lg:mb-20 lg:pt-10" /> */}
          <div className="row mb-10 items-center pt-0 lg:mb-20 lg:pt-20">
            <div className="justify-self-start lg:col-6">
              <div className="h-full">
                <Title
                  text="Bring Your Next<br/> Business Venture Online"
                  className="bbc-title mb-6 text-center text-bbc-30px text-bbc-brand-800 lg:mb-0 lg:text-left lg:text-bbc-40px"
                />
              </div>
            </div>
            <div className="lg:col-6">
              <div className="h-full">
                <LazyLoad>
                  <iframe
                    src="https://www.youtube.com/embed/8RkJwKEXKPU?start=2"
                    width="540"
                    height="303"
                    frameBorder="0"
                    title="Bring your next business venture online"
                    allow="accelerometer; autoplay;encrypted-media; gyroscope;picture-in-picture"
                    allowFullScreen
                    className=" w-full"
                  ></iframe>
                </LazyLoad>
              </div>
            </div>
          </div>
        </div>
        <section>
          <WhatMakeUsDifferent
            title=""
            data={dataJson.dataWhatMakeUsDifferent}
            className="bg-wmud py-[60px]"
          />
        </section>

        <section>
          {dataJson.dataOpenBankAccount &&
            typeof dataJson.dataOpenBankAccount === "object" &&
            Object.keys(dataJson.dataOpenBankAccount).length > 0 && (
              <StepSlider
                data={dataJson.dataOpenBankAccount}
                className="pt-0 lg:pt-0"
                title={dataJson.dataOpenBankAccount.title}
                imgAlt={dataJson.dataOpenBankAccount.alt}
              />
            )}
        </section>
        <section>
          <RequiredDocument
            title="What documents to prepare?"
            data={dataJson.dataRequiredDocument}
            sectionClassName="py-10 lg:py-20"
            backgroundImage="/assets/images/common/required-documents.png"
          />
        </section>
        <section>
          <div className="container">
            <EbookDownload
              title={dataJson.dataEbookDownload.title}
              imgSrc={dataJson.dataEbookDownload.imgSrc}
              contactFromId={dataJson.dataEbookDownload.contactFromId}
              hash={dataJson.dataEbookDownload.hash}
              dataForm={dataJson.dataEbookDownload.dataForm}
              wrapper={{ className: "mb-10 lg:mb-20" }}
              alt={dataJson.dataEbookDownload.alt}
              form={dataJson.dataEbookDownload.form}
            >
              <p className="mb-6">
                Chart out a clear roadmap towards company formation with our
                Singapore Incorporation checklist. Start your journey with the
                following insights on
              </p>
              <ul>
                {[
                  "Company pre-incorporation requirements",
                  "Compact guideline of application procedures",
                  "Checklist of business licenses",
                  "Post-incorporation and annual compliance keynotes",
                ].map((item, index) => (
                  <li key={index} className="mb-2 last:mb-0">
                    <CheckContent data={item} />
                  </li>
                ))}
              </ul>
            </EbookDownload>
          </div>
        </section>
        <section>
          <HowItWorks
            title="How we register your company"
            subTitle="in 4 easy steps"
            data={dataJson.dataHowItWorks}
          />
        </section>
      </div>
      {dataJson.dataCompanyNameCheck &&
        typeof dataJson.dataCompanyNameCheck === "object" &&
        Object.keys(dataJson.dataCompanyNameCheck).length > 0 && (
          <section>
            <CompanyNameCheck data={dataJson.dataCompanyNameCheck} />
          </section>
        )}
      <section className="relative">
        <div className=" absolute hidden h-1/2 w-full md:block lg:bg-bbc-brand-100"></div>
        <div className="container relative z-10">
          <div className="m-auto lg:col-10">
            <FormCountries
              title={dataJson.dataFormContact.title}
              description={dataJson.dataFormContact.description}
              country_id={191}
            />
          </div>
        </div>
        <Img
          src="/assets/images/wave/opposition_bottom-wave.png"
          width={1920}
          height={86}
          className="hidden  w-full lg:block"
          wrapper={{ className: "absolute w-full top-1/2 hidden md:block" }}
          alt="Wave bottom"
        />
      </section>
      <section>
        <div className="container">
          <div className="lg:col-10 lg:mx-auto">
            <Faqs
              data={dataJson.dataFaqs}
              title={dataJson.dataFaqs.title}
              description={dataJson.dataFaqs.description}
              defaultActiveKey={dataJson.dataFaqs.defaultActiveKey}
              multipleOpen={dataJson.dataFaqs.multipleOpen}
            />
          </div>
        </div>
      </section>
      <section className="mb-10 lg:mb-20">
        <div className="container">
          <Title className="title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800">
            Industry News & Insights
          </Title>
          <LazyLoad>
            <NewsSlider data={data} />
          </LazyLoad>
        </div>
      </section>
      <FormNewsLetter />
    </>
  );
};

export default SGCompanyIncorporationTemplate;
